module.exports = __webpack_public_path__ + "static/media/unavailable_blue.8687e0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/unavailable_blue.png
// module id = 2448
// module chunks = 0